export function determineCandleDuration(tradePlan) {
  let candleDuration = 1;
  if (
    tradePlan.entryTactics !== undefined &&
    tradePlan.entryTactics.CANDLE_BREAK !== undefined
  ) {
    candleDuration = tradePlan.entryTactics.CANDLE_BREAK.candleDuration;
  } else if (
    tradePlan.setupDetails !== undefined &&
    tradePlan.setupDetails.CONVICTION_CANDLE !== undefined
  ) {
    candleDuration = tradePlan.setupDetails.CONVICTION_CANDLE.candleDuration;
  } else if (
    tradePlan.setupDetails !== undefined &&
    tradePlan.setupDetails.ORB !== undefined
  ) {
    candleDuration = tradePlan.setupDetails.ORB.candleDuration;
  } else if (
    tradePlan.setupDetails !== undefined &&
    tradePlan.setupDetails.BREAK_CANDLE_TYPE !== undefined
  ) {
    candleDuration = tradePlan.setupDetails.BREAK_CANDLE_TYPE.candleDuration;
  } else if (
    tradePlan.setupDetails !== undefined &&
    tradePlan.setupDetails.CANDLE_PATTERN !== undefined
  ) {
    candleDuration = tradePlan.setupDetails.CANDLE_PATTERN.candleDuration;
  } else if (
    tradePlan.exitTactics !== undefined &&
    tradePlan.exitTactics.CANDLE_TRAIL !== undefined
  ) {
    candleDuration = tradePlan.exitTactics.CANDLE_TRAIL.candleDuration;
  } else if (
    tradePlan.exitTactics !== undefined &&
    tradePlan.exitTactics.GREEN_TO_RED_CANDLES !== undefined
  ) {
    candleDuration = tradePlan.exitTactics.GREEN_TO_RED_CANDLES.candleDuration;
  }
  return candleDuration;
}

export function determineBrokerage(tradePlan) {
  if (tradePlan.dataSource !== 'LIVE') return 'BACKTEST';
  return tradePlan.brokerage || '';
}
